export default {
  id: "productsSellTogether",
  name: "",
  description: "",
  report: {
    name: "Top Selling Products Breakdown",
    template: "products-sell-together",
    config: {
      dataType: "trends",
      dataSet: "ProductsSellTogether",
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
      filters: [],
    },
  },
};
